'use strict';

var React = require('react'),
    Page = require('../organisms/Page'),
    Loader = require('../atoms/Loader'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

function createAsyncPage(handlerPromiseFactory, displayName) {
  var AsyncPage = React.createClass({
    displayName: 'Async' + displayName,

    mixins: [PureRenderMixin],

    statics: {
      willTransitionTo(transition, params, query, callback) {
        AsyncPage.handlerPromiseFactory().then(handler => {
          if (handler.willTransitionTo) {
            handler.willTransitionTo(transition, params, query, callback);

            if (handler.willTransitionTo.length < 4) {
              callback();
            }
          } else {
            callback();
          }
        });
      },

      willTransitionFrom(transition, component, callback) {
        var handler = AsyncPage.cachedHandler;
        if (handler && handler.willTransitionFrom) {
          handler.willTransitionFrom(transition, component, callback);

          if (handler.willTransitionFrom.length < 3) {
            callback();
          }
        } else {
          callback();
        }
      }
    },

    getInitialState() {
      return {
        handler: AsyncPage.cachedHandler
      };
    },

    componentWillMount() {
      if (this.state.handler) {
        return;
      }

      AsyncPage.handlerPromiseFactory().then(handler => {
        AsyncPage.cachedHandler = handler;

        if (this.isMounted()) {
          this.setState({ handler: handler });
        }
      });
    },

    render() {
      var Handler = this.state.handler;
      if (Handler) {
        return <Handler {...this.props} />;
      }

      return (
        <Page>
          <Loader absoluteCenter />
        </Page>
      );
    }
  });

  if (module.makeHot) {
    AsyncPage = module.makeHot(AsyncPage, displayName);
  }

  AsyncPage.handlerPromiseFactory = handlerPromiseFactory;

  return AsyncPage;
}

module.exports = createAsyncPage;



/** WEBPACK FOOTER **
 ** ./pages/createAsyncPage.js
 **/